import React from "react";
import { Link } from "react-router-dom";
import markUrl from "../assets/logo-mark.png";
import fullUrl from "../assets/logo-full.png";

/**
 * Logo: mark + two-tone wordmark used in the top nav.
 * Props:
 *   variant: "mark" (default — shield + two-tone wordmark) | "full" (PNG with baked wordmark)
 *   size: "sm" | "md" | "lg"
 *   showWordmark: explicitly hide/show the text wordmark (default: true for "mark" variant)
 */
export const Logo = ({
    variant = "mark",
    size = "md",
    showWordmark = true,
    className = "",
}) => {
    const heightClass =
        size === "sm" ? "h-9" : size === "lg" ? "h-12" : "h-10";

    if (variant === "full") {
        const maxWidthClass =
            size === "sm" ? "max-w-[140px]" : size === "lg" ? "max-w-[220px]" : "max-w-[180px]";
        return (
            <Link
                to="/"
                aria-label="Cybersecurity Forefront — home"
                className={`inline-flex items-center group ${className}`}
                data-testid="brand-mark"
            >
                <img
                    src={fullUrl}
                    alt="Cybersecurity Forefront"
                    draggable={false}
                    className={`${maxWidthClass} w-auto h-auto select-none opacity-90 group-hover:opacity-100 transition-opacity duration-200`}
                />
            </Link>
        );
    }

    return (
        <Link
            to="/"
            aria-label="Cybersecurity Forefront — home"
            className={`inline-flex items-center gap-2.5 group select-none ${className}`}
            data-testid="brand-mark"
        >
            <span className="relative inline-flex">
                <img
                    src={markUrl}
                    alt=""
                    draggable={false}
                    className={`${heightClass} w-auto select-none transition-transform duration-200 group-hover:scale-[1.04]`}
                />
                <span
                    aria-hidden
                    className="pointer-events-none absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                    style={{
                        boxShadow: "0 0 24px rgba(3, 216, 243, 0.45)",
                    }}
                />
            </span>
            {showWordmark && (
                <span
                    className="hidden sm:inline-flex items-baseline font-sans font-semibold tracking-tight text-[15px] leading-none"
                    data-testid="brand-wordmark"
                >
                    <span className="text-text-primary">Cybersecurity</span>
                    <span className="text-accent-cyan ml-1">Forefront</span>
                </span>
            )}
        </Link>
    );
};

export default Logo;
